<template>
    <div class="banner bng-casino-banner-deposit-bonus">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/mobile/deposit_bonus.jpg' : '/static/banners/casino-home-banner/desktop/deposit_bonus.jpg'"
        />
        <div class="content">
            <div>
                <span>{{"components.common.banners.casino-banners.deposit-bonus.msg1" | translate}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 100">
                    <path d="M 0.0,100.0 40.0,50.0 0.0,0.0" />
                </svg>
            </div>
            <div>
                <strong>{{percent}}%</strong>
                <span>{{"components.common.banners.casino-banners.deposit-bonus.msg2" | translate}}</span>
            </div>
        </div>
        <div class="detailed">
            <a @click="goToBonusRules()">{{"components.common.banners.casino-banners.deposit-bonus.read more" | translate}}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-deposit-bonus',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.deposit && this.client.bonus.deposit.percent;
        }
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/deposit-bonus.vue